module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "txc1",
    attrs: {
      "id": "p0007-02-1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('i', [_vm._v("Me: Gracie, what should I write here? "), _c('br'), _vm._v("Grace: Mommeee, yooo shud wite “I lub you!” "), _c('br'), _vm._v("Me: That’s a great idea, sweet pea! I love you, Grace.")])])]), _vm._v(" "), _c('div', {
    staticClass: "figbody"
  }, [_c('img', {
    attrs: {
      "alt": "978071802239_0007_003.jpg",
      "id": "p0007-d6e31",
      "src": "images/978071802239_0007_003.jpg"
    }
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61cbe2c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chapter2.vue
// module id = 69
// module chunks = 0